<template>
  <v-menu
    ref="timepickerMenu"
    v-model="timepickerMenu"
    :close-on-content-click="false"
    :nudge-right="40"
    v-model:return-value="time"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="time"
        :label="label"
        prepend-icon="access_time"
        readonly
        v-bind="attrs"
        v-on="on"
        :rules="datepickerRules"
      ></v-text-field>
    </template>
    <v-time-picker
      v-if="timepickerMenu"
      v-model="time"
      full-width
      :format="formatTimer($i18n.locale)"
      @click:minute="$refs.timepickerMenu.save(time)"
    ></v-time-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'TimepickerOfRoom',

  props: {
    label: String
  },

  data: (vm) => ({
    time: null,
    timepickerMenu: false,
    datepickerRules: [(v) => !!v || 'Required']
  }),

  methods: {
    formatTimer(locale) {
      switch (locale) {
        case 'fr':
          return '24hr'
        case 'en':
          return 'ampm'
        case 'es':
          return '24hr'
        default:
          return 'ampm'
      }
    }
  },

  watch: {
    time(value) {
      this.$emit('save-time', { name: 'time', value: value })
    }
  }
}
</script>
